module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/39c019b1c9a3e8f30e35c6e601519af2.png";